function Bob() {
  return <div>THIS is bob</div>;
}

export default Bob;
